import { DisplayTicketLine, OrderItem } from '@accounting/interfaces/order-item';
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { bpcApi } from '@core/services/bpc-api.service';

export class TicketHelper {
  static processOrderItems(items: OrderItem[]): DisplayTicketLine[] {
    let orderLine: Partial<DisplayTicketLine> = { id: null };
    const newProcessedItems: DisplayTicketLine[] = [];
    items.forEach((orderItem: OrderItem) => {
      if (orderItem.order_id != orderLine.id) {
        orderLine = orderItem.order;
        orderLine.total_price = orderItem.total_price;
        orderLine.article_name = orderItem.order.description;
        orderLine.parent = true;
        orderLine._rowVariant = 'order';
        newProcessedItems.push(orderLine as DisplayTicketLine);
      } else {
        orderLine.total_price += orderItem.total_price;
      }
      newProcessedItems.push(orderItem);
    });
    return newProcessedItems;
  }

  static async getProcessedOrderItemsByTicketId(id: number): Promise<DisplayTicketLine[]> {
    return new Promise((resolve, reject) => {
      if (!id) {
        reject('ID param is needed');
      }
      const bpcRouterHelper = new BPCApiRouteHelper();

      const url = `${bpcRouterHelper.getEntityPath('order-item')}`;
      bpcApi
        .get(url, {
          params: {
            invoice_id: id,
            orderBy: 'order_id',
            orderDirection: 'asc',
            columns: [
              'id',
              'code',
              'description',
              'quantity',
              'price',
              'order_id',
              'article_name',
              'discount',
              'discount_type',
            ],
            relationFields: ['order'],
            computedFields: ['total_price', 'total_tax'],
            per_page: -1,
          },
        })
        .subscribe(
          (res: BPCGenericApiResponse) => {
            const orderItems = res.data;
            const lines = TicketHelper.processOrderItems(orderItems);
            resolve(lines);
          },
          error => {
            reject(error);
          },
        );
    });
  }
}
